import { useContext } from 'react';
import { ToastContext } from '@contexts/toast/toast-context';

export const useToast = () => useContext(ToastContext);
